import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import _ from "i18n";

import {
  setTaskTypeSelectedItem,
  setTaskCategorySelectedItem,
  setTaskTypeListFilterTitle,
  setTaskTypeListPaginationPage,
  initCapacityPlaningProduction,
  setTasksList
} from "Actions";
import { onSuccess, onError } from "Utils";
import { DIALOG_TYPES } from "../../config";
import {
  correlateTaskType,
  fetchTaskTypeList,
  liberateTaskType,
  fetchNonCategorizedTaskTypeCount,
  toggleBillableTaskType
} from "Thunks";

import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import CheckBoxBtn from "../Common/Checkbox/CheckBoxBtn";
import TTPPaginator from "../Common/TTPPaginator";
import TTPDialog from "../Common/TTPDialog";
import { PenIcon, ArchiveIcon, CloseIcon, GarbageIcon } from "../Common/Icons";

import styles from "./TaskTypeSettingsPage.local.scss";
import TaskTypeFilter from "../TaskTypeFilter/TaskTypeFilter";
import { Switch } from "antd";

class TaskTypeList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      confirmationModalIsVisible: false,
      deleteCategoryModalIsVisible: false,
      deleteValuationModalIsVisible: false,
      categoryDivIsVisible: false,
      filterFormIsVisible: false,
      selectedCategory: null,
      selectedValuation: null,
      searchCategories: [],
      searchValuations: [],
      loading: false,
      taskToUpdate: null,
      billableLoading: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideInputOptions.bind(this)
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideInputValuationOptions.bind(this)
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideSelectFrame.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { filter, paginationPage, pageSize } = prevProps;
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize
    ) {
      this.props.dispatch(fetchTaskTypeList());
    }
  }

  componentWillUnmount() {
    this.props.dispatch(setTaskTypeListFilterTitle(""));
  }

  handleToggleBillable = task => {
    const { dispatch, types, currentOrganization } = this.props;

    let tasksList = types;

    this.setState({ billableLoading: true, taskToUpdate: task.id });

    dispatch(toggleBillableTaskType(task.id, currentOrganization.id)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("taskTypeUpdated")
        });

        // eslint-disable-next-line array-callback-return
        tasksList.map((item, i) => {
          if (item.id === task.id) {
            tasksList[i].billable = task.billable ? 0 : 1;
          }
        });
        this.setState({ billableLoading: false, taskToUpdate: null });
        dispatch(setTasksList(tasksList));
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({ billableLoading: false, taskToUpdate: null });
      }
    );
  };

  renderBillableTaskTypeState = type => {
    const { taskToUpdate, billableLoading } = this.state;

    return (
      <div className={styles.etat_block}>
        <Switch
          checked={type.billable ? type.billable : false}
          onChange={() => this.handleToggleBillable(type)}
          checkedChildren={
            taskToUpdate === type.id && billableLoading ? (
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={styles.checkedChildren}
              />
            ) : (
              ""
            )
          }
          unCheckedChildren={
            taskToUpdate === type.id && billableLoading ? (
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={styles.unCheckedChildren}
              />
            ) : (
              ""
            )
          }
        />
      </div>
    );
  };
  handleRedirectBack = () => {
    this.props.dispatch(goBack());
  };

  // Task type list functions
  renderTaskTypeList = () => {
    const { types, selected } = this.props;

    return (
      <table className={styles.setting_table}>
        <thead key={"thead"}>
          <tr>
            <th>
              <CheckBoxBtn
                id="select-all"
                checked={selected.length === types.length && types.length > 0}
                onChange={() => this.handleSelectAllTypes()}
              />
              <span>{_("taskType")}</span>
            </th>
            <th>{_("categories")}</th>
            <th>{_("classification")}</th>
            <th>{_("isBillable")}</th>
          </tr>
        </thead>
        <tbody key={"tbody"}>
          {types.map((type, i) => {
            return (
              <tr
                key={type.id}
                className={
                  selected.includes(type.id)
                    ? styles.selected_line
                    : type.category
                      ? ""
                      : styles.free_line
                }
              >
                <td>
                  <CheckBoxBtn
                    id={type.id}
                    checked={selected.includes(type.id)}
                    onChange={() => this.handleSelectType(type.id)}
                  />
                  <span>{type.label}</span>
                </td>
                <td>
                  <div
                    className={
                      type.category
                        ? selected.includes(type.id)
                          ? styles.category_span_selected
                          : styles.category_span
                        : styles.category_span_free
                    }
                  >
                    {type.category
                      ? this.renderLabelByLangage(type.category)
                      : _("noCategory")}
                    {type.category && (
                      <div
                        className={styles.category_span_action}
                        onClick={() =>
                          this.handleDisplayDeleteCategoryModal(type)
                        }
                      >
                        <CloseIcon
                          dimension="17"
                          className={"light-sub-menu-icon"}
                        />
                      </div>
                    )}
                  </div>
                </td>
                <td>
                  <div
                    className={
                      type.valuation
                        ? styles.category_span
                        : type.category && type.category.valuation
                          ? styles.valuation_span
                          : styles.valuation_span_free
                    }
                  >
                    {type.valuation
                      ? this.renderLabelByLangage(type.valuation)
                      : type.category && type.category.valuation
                        ? this.renderLabelByLangage(type.category.valuation)
                        : _("noValuation")}
                    {type.valuation && (
                      <div
                        className={styles.category_span_action}
                        onClick={() =>
                          this.handleDisplayDeleteValuationModal(type)
                        }
                      >
                        <CloseIcon
                          dimension="17"
                          className={"light-sub-menu-icon"}
                        />
                      </div>
                    )}
                  </div>
                </td>
                <td>{this.renderBillableTaskTypeState(type)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  renderLabelByLangage = category => {
    let { lng } = this.props;
    if (category.label[lng]) return category.label[lng];
    if (category.label.en) return category.label.en;
    if (category.label.nl) return category.label.nl;
    if (category.label.fr) return category.label.fr;
  };

  handleSelectType = id => {
    let { selected } = this.props;

    let newSelectedItems = [...selected];
    if (newSelectedItems.includes(id)) {
      newSelectedItems.splice(newSelectedItems.indexOf(id), 1);
    } else {
      newSelectedItems.push(id);
    }
    this.props.dispatch(setTaskTypeSelectedItem(newSelectedItems));
  };

  handleSelectAllTypes = () => {
    let { selected, types } = this.props;
    if (selected.length === types.length) {
      selected = [];
    } else {
      selected = types.map(type => type.id);
    }
    this.props.dispatch(setTaskTypeSelectedItem(selected));
  };

  // Delete category modal functions
  handleDisplayDeleteCategoryModal = type => {
    this.setState({
      selectedType: type,
      deleteCategoryModalIsVisible: true
    });
  };

  handleDisplayDeleteValuationModal = type => {
    this.setState({
      selectedType: type,
      deleteValuationModalIsVisible: true
    });
  };

  cancelDeleteModal = () => {
    this.setState({
      selectedType: null,
      deleteCategoryModalIsVisible: false,
      deleteValuationModalIsVisible: false
    });
  };
  handleLiberateTypeFromValuation = () => {
    this.handleLiberateType("valuation");
  };

  handleLiberateTypeFromCategory = () => {
    this.handleLiberateType("category");
  };

  handleLiberateType = from => {
    let { selectedType } = this.state;
    this.setState({ loading: true });
    this.props.dispatch(liberateTaskType(selectedType, from)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("successfulAction"),
          body: _("correlateTaskTypeSuccess")
        });
        this.props.dispatch(fetchTaskTypeList());
        this.props.dispatch(fetchNonCategorizedTaskTypeCount());
        this.props.dispatch(initCapacityPlaningProduction());
        this.cancelDeleteModal();
      },
      error => {
        this.cancelDeleteModal();
        this.setState({ loading: false });
        onError(this.renderErrorText(error.response.data.errors[0].code));
      }
    );
  };

  // Categories select filter functions
  renderCategoriesSelect = () => {
    const { categories, selectedCategories, count } = this.props;
    const { categoryDivIsVisible } = this.state;

    let countSelect =
      selectedCategories.includes(null) || count > 0
        ? selectedCategories.length - 1
        : selectedCategories.length;

    return (
      <div
        ref={this.setSelectWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.categoryDivIsVisible
            ? styles.customed_select_opened
            : styles.customed_select_closed)
        }
      >
        <div
          className={
            styles.customed_select_header +
            " " +
            (this.state.categoryDivIsVisible
              ? styles.customed_select_header_down
              : styles.customed_select_header_up)
          }
          onClick={this.handleDisplayCategorySelectItems}
        >
          <label>{_("categories")}</label>
        </div>
        {categoryDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_label}>
              {_("selectCategoriesMessage")}
            </div>
            <div className={styles.customed_select_body_items}>
              <div className={styles.customed_select_body_all}>
                <CheckBoxBtn
                  id="select-all"
                  checked={
                    countSelect === categories.length && categories.length > 0
                  }
                  onChange={() => this.handleDeselectAllCategories(countSelect)}
                />
                <div className={styles.customed_select_body_item_label}>
                  {_("allCategories")}
                </div>
              </div>
              {count > 0 && (
                <div className={styles.customed_select_body_free} key="free">
                  <CheckBoxBtn
                    id={0}
                    checked={selectedCategories.includes(null)}
                    onChange={() => this.handleDeselectCategory(null)}
                  />
                  <div className={styles.customed_select_body_item_label}>
                    {_("typesNoCategories")}
                  </div>
                  <div className={styles.customed_select_body_free_count}>
                    {count}
                  </div>
                </div>
              )}
              {categories.map((item, index) => (
                <div className={styles.customed_select_body_item} key={index}>
                  <CheckBoxBtn
                    id={item.id}
                    checked={selectedCategories.includes(item.id)}
                    onChange={() => this.handleDeselectCategory(item.id)}
                  />
                  <div className={styles.customed_select_body_item_label}>
                    {this.renderLabelByLangage(item)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDeselectCategory = id => {
    let { selectedCategories } = this.props;

    let newSelectedItems = [...selectedCategories];
    if (selectedCategories.includes(id)) {
      newSelectedItems.splice(newSelectedItems.indexOf(id), 1);
    } else {
      newSelectedItems.push(id);
    }
    this.props.dispatch(setTaskCategorySelectedItem(newSelectedItems));
    this.props.dispatch(fetchTaskTypeList());
  };

  handleDeselectAllCategories = count => {
    let { categories, selectedCategories } = this.props;
    if (count === categories.length) {
      selectedCategories = [];
    } else {
      selectedCategories = categories.map(cat => cat.id);
      selectedCategories.push(null);
    }
    this.props.dispatch(setTaskCategorySelectedItem(selectedCategories));
    this.props.dispatch(fetchTaskTypeList());
  };

  handleDisplayCategorySelectItems = () => {
    this.setState(state => {
      return {
        categoryDivIsVisible: !state.categoryDivIsVisible
      };
    });
  };

  setSelectWrapperRef(node) {
    this.selectWrapperRef = node;
  }

  handleClickOutsideSelectFrame(event) {
    if (
      this.selectWrapperRef &&
      !this.selectWrapperRef.contains(event.target)
    ) {
      this.setState({ categoryDivIsVisible: false });
    }
  }

  // Categories input search functions
  renderInputSearchCategories = () => {
    const { selected } = this.props;
    const {
      searchCategories,
      searchValuations,
      selectedCategory,
      selectedValuation
    } = this.state;

    return selected.length > 0 ? (
      <div className={styles.inputs}>
        <div className={styles.category_search_input}>
          <div className={styles.category_search_input_div}>
            {selectedCategory ? (
              <div className={styles.category_search_input_selected}>
                {this.renderLabelByLangage(selectedCategory)}
              </div>
            ) : (
              <div>
                <PenIcon />
                <input
                  placeholder={_("searchMessageCategories")}
                  onChange={event =>
                    this.handleSearchInputChange(event, "category")
                  }
                  onFocus={event =>
                    this.handleSearchInputChange(event, "category")
                  }
                />
              </div>
            )}
          </div>
          {!selectedCategory &&
            searchCategories.length > 0 && (
              <div
                ref={this.setOptionsWrapperRef.bind(this)}
                className={styles.category_search_input_options}
              >
                {searchCategories.map((category, i) => {
                  return (
                    <div
                      key={`option__${category.id}`}
                      className={styles.category_search_input_option}
                      onClick={() =>
                        this.handleSelectCorrelatedCategory(category)
                      }
                    >
                      {this.renderLabelByLangage(category)}
                    </div>
                  );
                })}
              </div>
            )}
        </div>
        <div className={styles.category_search_input}>
          <div className={styles.category_search_input_div}>
            {selectedValuation ? (
              <div className={styles.category_search_input_selected}>
                {this.renderLabelByLangage(selectedValuation)}
              </div>
            ) : (
              <div>
                <PenIcon />
                <input
                  placeholder={_("searchMessageValuations")}
                  onChange={event =>
                    this.handleSearchInputChange(event, "valuation")
                  }
                  onFocus={event =>
                    this.handleSearchInputChange(event, "valuation")
                  }
                />
              </div>
            )}
          </div>
          {!selectedValuation &&
            searchValuations.length > 0 && (
              <div
                ref={this.setValuationOptionsWrapperRef.bind(this)}
                className={styles.category_search_input_options}
              >
                {searchValuations.map((valuation, i) => {
                  return (
                    <div
                      key={`option__${valuation.id}`}
                      className={styles.category_search_input_option}
                      onClick={() =>
                        this.handleSelectCorrelatedValuation(valuation)
                      }
                    >
                      {this.renderLabelByLangage(valuation)}
                    </div>
                  );
                })}
              </div>
            )}
        </div>
      </div>
    ) : (
      <div className={styles.category_search_infos}>
        <img src={"/img/icons/info.svg"} alt="" />
        <label>{_("chooseMessageCategories")}</label>
      </div>
    );
  };

  setOptionsWrapperRef(node) {
    this.optionsWrapperRef = node;
  }

  setValuationOptionsWrapperRef(node) {
    this.valuationOptionsWrapperRef = node;
  }

  handleClickOutsideInputOptions(event) {
    if (
      this.optionsWrapperRef &&
      !this.optionsWrapperRef.contains(event.target)
    ) {
      this.setState({ searchCategories: [] });
    }
  }

  handleClickOutsideInputValuationOptions(event) {
    if (
      this.valuationOptionsWrapperRef &&
      !this.valuationOptionsWrapperRef.contains(event.target)
    ) {
      this.setState({ searchValuations: [] });
    }
  }

  handleSearchInputChange = (event, action) => {
    let inputValue = event.target.value;
    action === "category"
      ? this.filterValuesByQuery(inputValue)
      : this.filterValuationValuesByQuery(inputValue);
  };

  filterValuesByQuery = input => {
    const { categories, lng } = this.props;
    let result = input
      ? categories.filter(cat =>
          cat.label[lng].toLowerCase().includes(input.toLowerCase())
        )
      : categories;
    this.setState({ searchCategories: result });
  };

  filterValuationValuesByQuery = input => {
    const { valuations, lng } = this.props;
    let result = input
      ? valuations.filter(val =>
          val.label[lng].toLowerCase().includes(input.toLowerCase())
        )
      : valuations;
    this.setState({ searchValuations: result });
  };

  handleSelectCorrelatedCategory = category => {
    this.setState({
      searchCategories: [],
      selectedCategory: category,
      confirmationModalIsVisible: true
    });
  };

  handleSelectCorrelatedValuation = valuation => {
    this.setState({
      searchValuations: [],
      selectedValuation: valuation,
      confirmationValuationModalIsVisible: true
    });
  };

  // Modal confirmation functions
  cancelConfirmationModal = () => {
    this.setState({
      selectedCategory: null,
      selectedValuation: null,
      confirmationModalIsVisible: false,
      confirmationValuationModalIsVisible: false
    });
  };

  handleSaveCorrelationTaskTypesToCategory = () => {
    this.handleSaveCorrelationTaskTypes("category");
  };

  handleSaveCorrelationTaskTypesToValuation = () => {
    this.handleSaveCorrelationTaskTypes("valuation");
  };

  handleSaveCorrelationTaskTypes = actionOn => {
    let { selectedCategory, selectedValuation } = this.state;
    let id =
      actionOn === "category" ? selectedCategory.id : selectedValuation.id;

    this.setState({ loading: true });
    this.props
      .dispatch(
        correlateTaskType(
          id,
          actionOn,
          selectedCategory ? selectedCategory.isBillable : ""
        )
      )
      .then(
        res => {
          this.setState({ loading: false });
          onSuccess(res, {
            title: _("successfulAction"),
            body: _("correlateTaskTypeSuccess")
          });
          this.props.dispatch(fetchTaskTypeList());
          this.props.dispatch(fetchNonCategorizedTaskTypeCount());
          this.props.dispatch(initCapacityPlaningProduction());
          this.cancelConfirmationModal();
        },
        error => {
          this.cancelConfirmationModal();
          this.setState({ loading: false });
          onError(this.renderErrorText(error.response.data.errors[0].code));
        }
      );
  };

  // Pagination functions
  renderPaginate = () => {
    let { types, paginationPage, pageSize, nbResult } = this.props;
    if (types.error != null && types.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleTaskTypeListPageChange}
        pageSize={pageSize}
        nbResult={nbResult}
        paginationPage={paginationPage}
      />
    );
  };

  handleTaskTypeListPageChange = ({ selected }) => {
    this.props.dispatch(setTaskTypeListPaginationPage(selected + 1));
  };

  render() {
    const { fetching, pageSize, types, nbResult } = this.props;
    const {
      loading,
      filterFormIsVisible,
      confirmationModalIsVisible,
      confirmationValuationModalIsVisible,
      deleteCategoryModalIsVisible,
      deleteValuationModalIsVisible
    } = this.state;

    return (
      <div className={styles.page_content}>
        <SettingPageHeader
          title={_("manageTasks")}
          onBack={() => this.handleRedirectBack()}
        />
        <div className={styles.block_content}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("tasksList")}</h2>
            <h3 className={styles.subtitle}>{_("assignCategorie")}</h3>
          </div>
          <div>
            <div className="rmodal__center">
              <div style={{ margin: "0px 3px 10px" }}>
                {this.renderInputSearchCategories()}
                <TaskTypeFilter
                  button={false}
                  pageSize={pageSize}
                  customAddOn={this.renderCategoriesSelect()}
                  filterFormIsVisible={false}
                  nbResult={nbResult}
                  label={"categoryNumber"}
                  marginLeft={"33em"}
                  fetching={fetching}
                />
              </div>
              {fetching ? (
                <div className={styles.ripple_loading}>
                  <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                </div>
              ) : (
                this.renderTaskTypeList()
              )}
            </div>
            <div
              className={`row align-center margin-bottom-2 ${filterFormIsVisible &&
                "add-margin-left"}`}
            >
              <div
                className={
                  filterFormIsVisible ? "column medium-12" : "column medium-11"
                }
              >
                {!fetching && types.length ? (
                  this.renderPaginate()
                ) : (
                  <div className="row pagination" />
                )}
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={confirmationModalIsVisible}
          loading={loading}
          TTPDialog={{
            approvedAction: this.handleSaveCorrelationTaskTypesToCategory,
            abortAction: this.cancelConfirmationModal,
            message: _("confirmationCategoriesMessage"),
            icon: <ArchiveIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("no"),
            type: DIALOG_TYPES.PRIMARY,
            title: "confirmationCategoriesTitle"
          }}
        />
        <TTPDialog
          showDialog={confirmationValuationModalIsVisible}
          loading={loading}
          TTPDialog={{
            approvedAction: this.handleSaveCorrelationTaskTypesToValuation,
            abortAction: this.cancelConfirmationModal,
            message: _("confirmationCategoriesMessage"),
            icon: <ArchiveIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("no"),
            type: DIALOG_TYPES.PRIMARY,
            title: "confirmationCategoriesTitle"
          }}
        />
        <TTPDialog
          showDialog={deleteCategoryModalIsVisible}
          loading={loading}
          TTPDialog={{
            approvedAction: this.handleLiberateTypeFromCategory,
            abortAction: this.cancelDeleteModal,
            message: _("deleteCategoriesMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("no"),
            type: DIALOG_TYPES.ALERT,
            title: "deleteCategoriesTitle"
          }}
        />
        <TTPDialog
          showDialog={deleteValuationModalIsVisible}
          loading={loading}
          TTPDialog={{
            approvedAction: this.handleLiberateTypeFromValuation,
            abortAction: this.cancelDeleteModal,
            message: _("deleteValuationsMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("no"),
            type: DIALOG_TYPES.ALERT,
            title: "deleteValuationsTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.taskTypes.list.fetching,
  fetched: state.taskTypes.list.fetched,
  error: state.taskTypes.list.error,
  types: state.taskTypes.list.items,
  count: state.params.countTaskType.count,
  paginationPage: state.taskTypes.list.paginationPage,
  pageSize: state.taskTypes.list.pageSize,
  nbResult: state.taskTypes.list.nbResult,
  selected: state.taskTypes.list.selected,
  categories: state.taskTypes.categories.items,
  valuations: state.categoriesSettings.valuations.items,
  selectedCategories: state.taskTypes.categories.selected,
  currentOrganization: state.auth.currentOrganization,
  filter: state.taskTypes.list.filter,
  lng: state.params.lng
});

export default connect(mapStateToProps)(TaskTypeList);



// WEBPACK FOOTER //
// ./src/components/TaskType/TaskTypeList.js